import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

export default function AddAdvance({availableWorkers}) {

const [newAdvance, setNewAdvance]=useState({});
const api_url = process.env.REACT_APP_API_URL;
const complex_name = localStorage.getItem('complex_name');
const role = localStorage.getItem('role');
const [saveStatus, setSaveStatus] = useState("");
const [saveButtonDisable, setSaveButtonDisable] = useState(false);
const [advanceDate, setAdvanceDate] = useState('');
const [recipientType, setRecipientType] = useState('worker'); // 'worker' или 'user'
const [advanceType, setAdvanceType] = useState('advance'); // 'advance' или 'goods'
const [availableUsers, setAvailableUsers] = useState([]);

// Загружаем список Users (админов/кассиров) при выборе типа получателя
useEffect(() => {
    async function fetchUsers() {
        if (recipientType === 'user') {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
                body: JSON.stringify({ complex_name: complex_name })
            };
            const response = await fetch(api_url + "/api/availableAdmins", requestOptions);
            const body = await response.json();
            setAvailableUsers(body.map(({ user_id, fullname, complex }) => ({ userId: user_id, fullName: fullname, complex: complex })));
        }
    }
    fetchUsers();
}, [recipientType, api_url, complex_name]);

function handleChange(e) {
    setNewAdvance({
      ...newAdvance,
      [e.target.name]: e.target.value
    });
}

async function createAdvance() {

    setSaveButtonDisable(true);

    let full_name;
    let requestBody;

    if (recipientType === 'worker') {
        let worker_info = availableWorkers.find((s) => s.workerId === newAdvance.recipientId);
        full_name = worker_info.fullName;
        requestBody = {
            worker_id: newAdvance.recipientId,
            recipient_type: 'worker',
            full_name: full_name,
            advance_amount: newAdvance.advanceAmount,
            complex_name: complex_name,
            comment: newAdvance.comment,
            advance_type: advanceType
        };
    } else {
        let user_info = availableUsers.find((s) => s.userId === newAdvance.recipientId);
        full_name = user_info.fullName;
        requestBody = {
            user_id: newAdvance.recipientId,
            recipient_type: 'user',
            full_name: full_name,
            advance_amount: newAdvance.advanceAmount,
            complex_name: complex_name,
            comment: newAdvance.comment,
            advance_type: advanceType
        };
    }

    // Добавляем дату аванса только если роль супер-админ и дата выбрана
    if (role === "2" && advanceDate) {
        requestBody.advance_date = advanceDate;
    }

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
        body: JSON.stringify(requestBody)
    };

    const saving_visit = await fetch(api_url+"/api/addAdvance", requestOptions);

    const body = await saving_visit.json();
    if (body.message === "Advance added successfully!") {
      setSaveStatus("success");
    }
    else {
      setSaveStatus("error");
      setSaveButtonDisable(false);
    }
}

return (
    <div className='edit-worker-modal'>
    <h1 className="modal-header"> Добавить аванс </h1>
      <Box sx={{ maxWidth: 550, margin: `auto`, pt: 5, pb: 5 }}>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="recipient-type-label">Тип получателя:</InputLabel>
        <Select
          value={recipientType}
          label="Тип получателя:"
          onChange={(e) => {
            setRecipientType(e.target.value);
            setNewAdvance({ ...newAdvance, recipientId: '' });
          }}
        >
        <MenuItem value="worker">Мойщик/Кассир/КК</MenuItem>
        <MenuItem value="user">Админ/HR-директор</MenuItem>
        </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="advance-type-label">Тип записи:</InputLabel>
        <Select
          value={advanceType}
          label="Тип записи:"
          onChange={(e) => setAdvanceType(e.target.value)}
        >
        <MenuItem value="advance">Аванс</MenuItem>
        <MenuItem value="goods">Товары</MenuItem>
        </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="recipient-select-label">Сотрудник:</InputLabel>
        <Select
          value={newAdvance.recipientId || ''}
          label="Сотрудник:"
          name="recipientId"
          fullWidth
          onChange={handleChange}
        >
        {recipientType === 'worker'
          ? availableWorkers.map(({workerId, fullName}) => (
              <MenuItem key={workerId} value={workerId}> {fullName} </MenuItem>
            ))
          : availableUsers.map(({userId, fullName}) => (
              <MenuItem key={userId} value={userId}> {fullName} </MenuItem>
            ))
        }
        </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Сумма</InputLabel>
        <OutlinedInput
          name="advanceAmount"
          value={newAdvance.advanceAmount || ''}
          onChange={handleChange}
          label="Сумма"
        />
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Комментарий</InputLabel>
        <OutlinedInput
          id="comment"
          name="comment"
          value={newAdvance.comment || ''}
          onChange={handleChange}
          label="Комментарий"
        />
        </FormControl>

        {role === "2" && (
        <TextField
          sx={{mb:1.5, mt:1.5}}
          fullWidth
          label="Дата аванса"
          type="date"
          value={advanceDate}
          onChange={(e) => setAdvanceDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        )}

        <Button variant="contained"
            sx={{mb:1.5, mt:1.5}} fullWidth
            disabled={saveButtonDisable}
            color="success"
            className="mr10"
            onClick={() => createAdvance()}>Добавить {advanceType === 'advance' ? 'аванс' : 'товары'}</Button>
        {saveStatus === "error" && <Alert severity="error">Ошибка, проверьте правильность введенных данных!</Alert>}
        {saveStatus === "success" && <Alert severity="success">Изменения успешно сохранены!</Alert>}
        </Box>
    </div>
)}
